import React, { useState, useEffect } from "react";

export default function Preloader() {
  const [progress, setProgress] = useState(0);
  const [statusText, setStatusText] = useState("Inițializare conexiune...");
  const [hidden, setHidden] = useState(false);
  const [fade, setFade] = useState(false);

  useEffect(() => {
    // Progressive loading sequence for gaming network
    const statuses = [
      { pct: 15, text: "Inițializare noduri de rețea..." },
      { pct: 38, text: "Sincronizare servere CS2 & CS 1.6..." },
      { pct: 64, text: "Încărcare profil operator & loadout..." },
      { pct: 88, text: "Verificare protocoale Anti-Cheat..." },
      { pct: 100, text: "Bine ai venit pe Indungi România!" }
    ];

    let currentStep = 0;
    const interval = setInterval(() => {
      if (currentStep < statuses.length) {
        setProgress(statuses[currentStep].pct);
        setStatusText(statuses[currentStep].text);
        currentStep++;
      } else {
        clearInterval(interval);
        setTimeout(() => setFade(true), 250);
        setTimeout(() => setHidden(true), 900);
      }
    }, 170);

    return () => clearInterval(interval);
  }, []);

  if (hidden) return null;

  return (
    <div
      className={`fixed inset-0 z-[999999] bg-[#05070c] flex flex-col items-center justify-center select-none transition-all duration-700 ${
        fade ? "opacity-0 pointer-events-none scale-105" : "opacity-100 scale-100"
      }`}
      style={{
        backgroundImage: "radial-gradient(ellipse at center, #0f172a 0%, #05070c 75%)"
      }}
      data-testid="indunji-preloader"
    >
      {/* Background Cyber Scanlines & Tactical Grid */}
      <div 
        className="absolute inset-0 pointer-events-none opacity-25"
        style={{
          backgroundImage: "linear-gradient(rgba(255, 255, 255, 0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.04) 1px, transparent 1px)",
          backgroundSize: "36px 36px"
        }}
      />
      <div 
        className="absolute inset-0 pointer-events-none opacity-10"
        style={{
          backgroundImage: "repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(255, 79, 0, 0.4) 2px, rgba(255, 79, 0, 0.4) 4px)"
        }}
      />

      {/* Central Animated Hologram Core */}
      <div className="relative z-10 flex flex-col items-center max-w-sm px-6 text-center space-y-6">
        
        {/* Animated Rings & Core Monogram */}
        <div className="relative w-28 h-28 flex items-center justify-center">
          {/* Outer Rotating Glowing Ring */}
          <div 
            className="absolute inset-0 rounded-full border-2 border-dashed border-[#FF4F00]/50 animate-spin"
            style={{ animationDuration: "10s" }}
          />
          {/* Middle Reverse Ring */}
          <div 
            className="absolute inset-2 rounded-full border-2 border-[var(--tf-primary)]/40 border-t-transparent border-b-transparent animate-spin"
            style={{ animationDirection: "reverse", animationDuration: "5s" }}
          />
          {/* Inner Glowing Core Orb */}
          <div className="absolute inset-4 rounded-full bg-gradient-to-tr from-[#FF4F00]/25 via-[#00e5ff]/20 to-[#00ff88]/20 backdrop-blur-md border border-white/10 shadow-[0_0_35px_rgba(255,79,0,0.5)] animate-pulse" />

          {/* Central Monogram */}
          <div className="relative z-10 flex flex-col items-center justify-center">
            <span className="font-chakra font-black text-3xl text-white tracking-wider drop-shadow-[0_0_15px_rgba(255,79,0,0.85)]">
              IDG
            </span>
            <span className="text-[8px] font-mono font-bold text-amber-400 tracking-widest -mt-1 uppercase">
              EST. 2010
            </span>
          </div>
        </div>

        {/* Brand Headline */}
        <div className="space-y-1">
          <h2 className="font-chakra font-black text-2xl sm:text-3xl uppercase tracking-widest text-white drop-shadow-[0_0_20px_rgba(255,255,255,0.2)]">
            INDUNGI <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#FF4F00] via-amber-400 to-[#00ff88]">ROMÂNIA</span>
          </h2>
          <p className="text-[10px] font-mono uppercase tracking-[0.25em] text-zinc-400">
            ESPORTS & COMMUNITY NETWORK
          </p>
        </div>

        {/* Progress Bar Container */}
        <div className="w-full space-y-2 pt-2">
          {/* Bar */}
          <div className="w-full h-2.5 bg-[#090e17] rounded-full overflow-hidden p-0.5 border border-white/10 shadow-inner relative">
            <div 
              className="h-full rounded-full bg-gradient-to-r from-[#FF4F00] via-amber-400 to-[#00ff88] transition-all duration-300 shadow-[0_0_12px_rgba(255,79,0,0.8)] relative"
              style={{ width: `${progress}%` }}
            >
              {/* Glowing Scanlight Tip */}
              <div className="absolute top-0 right-0 bottom-0 w-3 bg-white/70 rounded-full blur-[1px]" />
            </div>
          </div>

          {/* Status Text & Percentage */}
          <div className="flex items-center justify-between text-[11px] font-mono">
            <span className="text-zinc-400 truncate flex items-center gap-1.5">
              <span className="w-1.5 h-1.5 rounded-full bg-[#FF4F00] animate-ping shrink-0" />
              <span className="truncate">{statusText}</span>
            </span>
            <span className="font-chakra font-black text-amber-400 shrink-0 ml-2">
              {progress}%
            </span>
          </div>
        </div>

        {/* Bottom Node Tag */}
        <div className="text-[9px] font-mono text-zinc-500 uppercase tracking-widest pt-2">
          SECURE PROTOCOL // 1000 FPS READY
        </div>

      </div>
    </div>
  );
}
